import styled from 'styled-components/macro';
import Typography from '@material-ui/core/Typography';

const Headline3 = styled(Typography).attrs({
  variant: 'h3',
  component: 'h3',
})`
  font-weight: bold;
  text-align: left;
  white-space: pre;
`;

export default Headline3;
